<template>
  <filter-wrapper @submit="submit">
    <div class="filter-flex">
      <div class="filter__row">
        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('autoinformer.stats.filter.campaign') }}
          </label>
          <div class="filter__item__body">
            <select-campaign v-model="form.campaign_id" />
          </div>
        </div>

        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('autoinformer.stats.filter.task_number') }}
          </label>
          <div class="filter__item__body">
            <i-input v-model="form.dst" type="number" :clearable="true" />
          </div>
        </div>

        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('autoinformer.stats.filter.src') }}
          </label>
          <div class="filter__item__body">
            <i-input v-model="form.src" type="number" :clearable="true" />
          </div>
        </div>

        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('autoinformer.stats.filter.client_action') }}
          </label>
          <div class="filter__item__body">
            <client-actions-input v-model="form.keys" />
          </div>
        </div>
      </div>

      <div class="filter__row">
        <select-state v-model="form.state" class="col-3" />
        <div class="filter__item filter__item--datepicker col-6">
          <label class="filter__item__title">
            {{ $t('shared.component.filter.period') }}
          </label>
          <div class="filter__item__body">
            <date-range-picker v-model="form.call_date" />
          </div>
        </div>

        <div class="filter__row ml-auto">
          <div class="filter__item filter__item--button">
            <i-button html-type="submit" type="primary">
              {{ $t('shared.component.filter.show_result') }}
            </i-button>
          </div>
          <div class="filter__item filter__item--button">
            <i-button type="primary" icon="md-arrow-up" @click="make_export">
              {{ $t('db.recipient.button.export') }}
            </i-button>
          </div>
        </div>
      </div>
    </div>
  </filter-wrapper>
</template>

<script>
  import FilterWrapper from '@shared/components/filter-base';
  import SelectState from './campaigns-filter-state';
  import ClientActionsInput from './client-actions-input';
  import SelectCampaign from './campaigns-filter-select';
  import { mapActions, mapGetters } from 'vuex';
  import { initSearchStateByPeriod, parseSearchStateByPeriod } from '@shared/helpers/date_format';
  import { StatsService } from '@autoinformer/services/StatsService';

  export default {
    components: {
      FilterWrapper,
      SelectState,
      ClientActionsInput,
      SelectCampaign
    },
    data: () => ({
      form: {
        campaign_id: null,
        number: '',
        src: '',
        dst: '',
        state: null,
        call_date: initSearchStateByPeriod(),
        number_in_task: 0,
        keys: ''
      }
    }),

    computed: {
      ...mapGetters('autoinformer/stats/details/table', ['filter'])
    },
    methods: {
      ...mapActions('autoinformer/stats/details/table', ['search']),

      submit() {
        const { start, end } = parseSearchStateByPeriod(this.form.call_date);
        const { dst, src, state, campaign_id, keys } = this.form;

        const params = {
          campaign_id,
          keys,
          src,
          dst,
          state,
          date_start_from: start,
          date_start_to: end
        };

        this.search(params);
      },
      make_export() {
        const { start, end } = parseSearchStateByPeriod(this.form.call_date);
        const { dst, src, state, campaign_id, keys } = this.form;

        const params = {
          campaign_id,
          keys,
          src,
          dst,
          state,
          date_start_from: start,
          date_start_to: end
        };

        StatsService.export(params)
          .then(() => {
            this.$noty.success(this.$t('shared.component.noty.export_pbx'));
          })
          .catch((error) => this.$noty.server_error(error));
      }
    }
  };
</script>
